/* eslint-disable no-unused-vars */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-inner-declarations */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-empty */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-state */
import {
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  FormHelperText,
  // TextField,
  ListSubheader,
} from "@mui/material";
import React, { Component } from "react";
import { IconButton } from "@mui/material";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
  DatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Select from "antd/es/select";
import Radio from "antd/es/radio";
import PublishIcon from "@material-ui/icons/Publish";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TimePicker from "antd/es/time-picker";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Mail from "../../images/TxtMailIcon.svg";
import search from "../../images/search.svg";
import Delete from "../../images/Delete_icon.png";
import SelectionIcon from "../../images/Select_icon.png";
import TimerIcon from "../../images/timesheet.svg";
import { Visibility, VisibilityOff, Search } from "@material-ui/icons";
import "./labelbox.css";
import moment from "moment/moment";
import {
  formatDateOnlyYmd,
  formatLocalCalendarDateYmd,
  parseYmdToLocalDate,
  parseYmdToLocalDateStart,
} from "../../utils/dateOnly";
import { parseTimeToMoment } from "../../utils/common";
import { ReactComponent as Calendar } from "../../images/calendar.svg";

export default class Labelbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upload_model: false,
      gender: "M",
      open: false,
      value: null,
      selectedtime: props.value,
      selecteddate: props.value ? props.value : null,
      showCalendar: false,
      showPassword: false,
      ...this.state,
      selectSearch: "",
      selectOpen: false,
      selectWidth: null,
    };
  }

  datepickerChange(date) {
    if (date === "Invalid Date") {
      this.props.invalidate && this.props.invalidate(date);
      return;
    }
    const datefmt =
      formatLocalCalendarDateYmd(date) ||
      formatDateOnlyYmd(date) ||
      (date ? moment(date).format("YYYY-MM-DD") : "");
    this.props.changeData && this.props.changeData(datefmt);
  }

  timepickerChange(time) {
    // var timeformat = dateFormat(time, "hh:MM:ss");
    this.props.changeData && this.props.changeData(time);
  }

  showhidePassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  openDatePicker = () => {
    if (!this.props.disabled) {
      this.setState({ showCalendar: true });
    }
  };

  closeDatePicker = () => {
    this.setState({ showCalendar: false });
  };

  /** Omit bounds when unset so MUI picker defaults (1900–2100) apply for year/month views. */
  resolvePickerBoundDate(propValue) {
    if (propValue == null || propValue === "") return undefined;
    return parseYmdToLocalDateStart(propValue) || propValue;
  }

  formatDate(date) {
    console.log("format date method triggers", date);
    if (!date) return new Date().toLocaleString();

    // // Get the timezone from browser using native methods
    // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const dateTmp = Date.parse(date.toLocaleString());

    // const localDate = formatInTimeZone(dateTmp, {
    //   timeZone: timezone,
    // });

    // return format(localDate, 'yyyy-MM-dd');
  }

  componentWillReceiveProps(props) {
    if (props.type === "datepicker") {
      //console.log("the props of the date picker====>", props)

      if (Number.isNaN(new Date(props.value).getTime())) {
      } else {
        // var datefmt = dateFormat(props.value && props.value, 'yyyy-mm-dd');
        // this.setState({ selecteddate: datefmt })
      }
    }
    if (props.gendervalue) {
      this.setState({ gender: props.gendervalue });
    }
  }

  searchBuffer = "";
  searchTimeout = null;

  setSelectWidth = (event) => {
    const width =
      event?.currentTarget?.clientWidth || event?.target?.clientWidth || null;

    if (width && width !== this.state.selectWidth) {
      this.setState({ selectWidth: width });
    }
  };

  renderinput(data) {
    if (data.type === "label") {
      return (
        <div className="labeltxt">
          {data.label && <div>{data.label}</div>}
          <div className={`${this.props.classes} label-read-only`}>
            {data.value || "---"}
          </div>
        </div>
      );
    } else if (data.type === "text") {
      //change 1
      return (
        <div className="formdiv inputlabel">
          <TextField
            fullWidth
            label={data.labelname}
            required={data.required}
            variant="outlined"
            type={
              data.password
                ? this.state.showPassword
                  ? "text"
                  : "password"
                : "text"
            }
            value={this.props.value}
            placeholder={this.props.placeholder}
            disabled={this.props.disabled}
            error={data.error}
            helperText={data.error ? data.errmsg : ""}
            inputProps={{
              maxLength: this.props.maxlength,
              readOnly: !!(this.props.disabled || this.props.readOnly),
            }}
            autoComplete={this.props.autocomplete ? "" : "new-password"}
            onChange={(e) =>
              !this.props.disabled &&
              !this.props.readOnly &&
              this.props.changeData &&
              this.props.changeData(e.target.value)
            }
            onBlur={(e) =>
              this.props.SubmitData && this.props.SubmitData(e.target.value)
            }
            onKeyDown={(e) =>
              this.props.onKeyEnter &&
              (e.code === "Enter" || e.key === "Enter") &&
              this.props.onKeyEnter(e.target.value)
            }
            InputProps={{
              className: this.props.readOnly ? "labelbox-readonly" : undefined,
              endAdornment: data.password && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => this.showhidePassword()}
                    edge="end"
                  >
                    {this.state.showPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      );
    } else if (data.type === "number") {
      return (
        <div className="formdiv">
          <label className="labeltxt">{data.labelname}</label>
          <div>
            <input
              className={`${data.error && "brdred"} brdrcls inputID`}
              min="0"
              value={this.props.value}
              type="number"
              onChange={(e) =>
                this.props.changeData && this.props.changeData(e.target.value)
              }
              // onKeyDown={(e) =>
              //   (e.key === "e" || e.key === "+" || e.key === "-") &&
              //   e.preventDefault()
              // }
              disabled={this.props.disabled}
              onKeyDown={(e) =>
                this.props.onKeyEnter &&
                (e.code === "Enter" || e.key === "Enter") &&
                this.props.onKeyEnter(e.target.value)
              }
            />
            <div className="Errormsg">
              <div>{data.error && data.errmsg}</div>
            </div>
          </div>
        </div>
      );
    } else if (data.type === "textarea") {
      return (
        <div className="formdiv">
          {data.labelname && (
            <label className="labeltxt">{data.labelname}</label>
          )}
          <div>
            <textarea
              className={`${data.error && "brdred"} txtarea`}
              rows={this.props.rows || 1}
              // maxRows={this.props.maxRows}
              cols="50"
              value={this.props.value}
              placeholder={this.props.placeholder}
              onChange={(e) =>
                this.props.changeData && this.props.changeData(e.target.value)
              }
              disabled={this.props.disabled}
              onKeyDown={(e) =>
                this.props.onKeyEnter &&
                (e.code === "Enter" || e.key === "Enter") &&
                this.props.onKeyEnter(e.target.value)
              }
            />
            <div className="Errormsg">
              <div>{data.error && data.errmsg}</div>
            </div>
          </div>
        </div>
      );
    } else if (data.type === "checkbox") {
      return (
        <div className="check">
          <input
            type="checkbox"
            checked={this.props.checked}
            onChange={(e) =>
              this.props.changeData && this.props.changeData(e.target.checked)
            }
            // inputProps={{ 'aria-label': 'primary checkbox' }}
            name={this.props.name && this.props.name}
            classname={this.props.classes && this.props.classes}
            disabled={!!this.props.disabled}
            id={this.props.id || "labelbox-check"}
            required={!!this.props.required}
            size={this.props.size && this.props.size}
            ref={this.props.checkRef}
          />
          {this.props.label && (
            <label for={this.props.id || "labelbox-check"}>
              {this.props.label}
            </label>
          )}
          {/* <label>{this.props.label && this.props.label}</label> */}
        </div>
      );
    } else if (data.type === "radio") {
      return (
        <div className="formdiv">
          <div>
            <Radio.Group
              className={`${data.error && "brdred"}`}
              options={this.props.options && this.props.options}
              onChange={(e) =>
                this.props.changeData && this.props.changeData(e.target.value)
              }
              value={this.props.value && this.props.value}
              optionType="default"
              buttonStyle="solid"
              size={this.props.size && this.props.size}
              disabled={this.props.disabled && this.props.disabled}
              onKeyDown={(e) =>
                this.props.onKeyEnter &&
                (e.code === "Enter" || e.key === "Enter" || e.keyCode === 13) &&
                this.props.onKeyEnter(e.target.value)
              }
            />
            <div className="Errormsg">
              <div>{data.error && data.errmsg}</div>
            </div>
          </div>
        </div>
      );
    } else if (data.type === "datepicker") {
      const pickerMinDate = this.resolvePickerBoundDate(this.props.minDate);
      const pickerMaxDate = this.resolvePickerBoundDate(this.props.maxDate);
      const pickerViews = this.props.view || ["year", "month", "date"];

      return (
        <div className="formdiv inputlabel">
          {/* remove the separate labeldiv and let MUI render the floating label */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <FormControl fullWidth variant="outlined" error={data.error}>
              <KeyboardDatePicker
                label={data.labelname}
                required={data.required} // mark required
                helperText={data.error ? data.errmsg : null} // error helper (KeyboardDatePicker will pass to inner TextField)
                inputVariant="outlined"
                placeholder={this.props.placeholder} // optional placeholder (within field when empty)
                disableToolbar={this.props.disableToolbar}
                autoOk
                disabled={this.props.disabled}
                views={pickerViews}
                openTo={this.props.openTo || "date"}
                clearable={false}
                disableFuture={this.props.disableFuture || false}
                disablePast={this.props.disablePast}
                shouldDisableDate={this.props.shouldDisableDate}
                {...(pickerMinDate ? { minDate: pickerMinDate } : {})}
                {...(pickerMaxDate ? { maxDate: pickerMaxDate } : {})}
                format={
                  this.props.format === "MMM-yyyy" ? "MMM-yyyy" : "MMM dd yyyy"
                }
                margin="normal"
                open={this.state.showCalendar}
                onOpen={this.openDatePicker}
                onClose={this.closeDatePicker}
                onClick={this.openDatePicker}
                InputProps={{
                  readOnly: true,
                  onClick: this.openDatePicker,
                }}
                keyboardIcon={<Calendar width={20} height={20} />}
                value={parseYmdToLocalDate(this.props.value) || null}
                onChange={(...date) => this.datepickerChange(...date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                  onClick: this.openDatePicker,
                }}
                // ensure label shrinks when value exists (optional)
                InputLabelProps={{
                  shrink: !!this.props.value || this.state.showCalendar,
                  style:
                    !this.props.value && !this.state.showCalendar
                      ? {
                          transform: "translate(14px, 17px) ",
                        }
                      : undefined,
                }}
              />
            </FormControl>
          </MuiPickersUtilsProvider>
        </div>
      );
    } else if (data.type === "timepicker") {
      return (
        <div className="formdiv">
          <label className="labeltxt">{data.labelname}</label>
          <div>
            {/* <TimePicker value={this.props.value} onChange={(time)=>this.onChange(time)} /> */}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardTimePicker
                margin="normal"
                inputVariant="outlined"
                id="time-picker"
                value={this.props.value || new Date()}
                onChange={(time) => this.timepickerChange(time)}
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
                minTime={this.props.minTime && this.props.minTime}
                maxTime={this.props.maxTime && this.props.maxTime}
                InputProps={{ readOnly: true }}
                keyboardIcon={
                  <img
                    src={TimerIcon}
                    alt=""
                    className="labelboxTimePicker"
                    minTime={this.props.minTime && this.props.minTime}
                    maxTime={this.props.maxTime && this.props.maxTime}
                  />
                }
                disabled={this.props.disabled}
              />
            </MuiPickersUtilsProvider>
            <div className="Errormsg">
              <div>{data.error && data.errmsg}</div>
            </div>
          </div>
        </div>
      );
    } else if (data.type === "select") {
      // Check if value exists in dropdown options
      const currentValue = this.props.value ?? "";
      // Ensure dropdown is an array before calling .some()
      const dropdownArray = Array.isArray(data.dropdown) ? data.dropdown : [];
      // Sort dropdownArray alphabetically by display value
      const getDisplayValue = (item) =>
        (item.value || item[data.opt_value] || "").toString().toLowerCase();
      const sortedDropdown = [...dropdownArray].sort((a, b) => {
        // Options with keepAtTop stay at the top (e.g. "Clear selection")
        if (a.keepAtTop && !b.keepAtTop) return -1;
        if (!a.keepAtTop && b.keepAtTop) return 1;
        if (a.keepAtTop && b.keepAtTop) return 0;
        const aVal = getDisplayValue(a);
        const bVal = getDisplayValue(b);
        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
      });

      const isMultiple = data.multiple === true;
      const currentValueMultiple = Array.isArray(this.props.value)
        ? this.props.value
        : [];

      const valueInDropdown =
        sortedDropdown.length > 0 &&
        (isMultiple
          ? currentValueMultiple.length >= 0
          : sortedDropdown.some((item) => {
              const itemValue =
                item.id !== undefined
                  ? item.id
                  : item[data.opt_id] !== undefined
                    ? item[data.opt_id]
                    : item.value !== undefined
                      ? item.value
                      : "";
              return String(itemValue) === String(currentValue);
            }));

      // If disabled and value is not in dropdown, show as text (for "Others" case)
      if (
        !isMultiple &&
        this.props.disabled &&
        currentValue &&
        !valueInDropdown
      ) {
        return (
          <div className="formdiv inputlabel">
            {data.labelname && (
              <label className="labeltxt">{data.labelname}</label>
            )}
            <div className="label-read-only">{currentValue}</div>
            {data.error && (
              <FormHelperText>
                {data.errmsg || "Selection Required"}
              </FormHelperText>
            )}
          </div>
        );
      }
      if (isMultiple) {
        const valueArr = currentValueMultiple.map((v) => String(v));
        return (
          <div className="formdiv inputlabel">
            <FormControl fullWidth variant="outlined" error={data.error}>
              {data.labelname && (
                <InputLabel required={data.required}>
                  {data.labelname}
                </InputLabel>
              )}
              <MUISelect
                multiple
                label={data.labelname}
                value={valueArr}
                disabled={this.props.disabled}
                onMouseDown={(e) => this.setSelectWidth(e)}
                onOpen={(e) => {
                  this.setSelectWidth(e);
                }}
                onChange={(e) => {
                  const next = e.target.value;
                  this.props.changeData &&
                    this.props.changeData(Array.isArray(next) ? next : []);
                  this.setState({ selectSearch: "" });
                }}
                renderValue={(selected) =>
                  Array.isArray(selected) && selected.length > 0
                    ? selected
                        .map(
                          (id) =>
                            sortedDropdown.find(
                              (item) =>
                                String(
                                  item.id !== undefined
                                    ? item.id
                                    : item[data.opt_id] !== undefined
                                      ? item[data.opt_id]
                                      : item.value,
                                ) === String(id),
                            )?.value || id,
                        )
                        .join(", ")
                    : "Select..."
                }
                MenuProps={{
                  disablePortal: true,
                  PaperProps: {
                    style: {
                      maxHeight: 400,
                      ...(this.state.selectWidth
                        ? {
                            width: this.state.selectWidth,
                            minWidth: this.state.selectWidth,
                          }
                        : {}),
                    },
                  },
                }}
              >
                {sortedDropdown.map((item, index) => {
                  const itemId =
                    item.id !== undefined
                      ? item.id
                      : item[data.opt_id] !== undefined
                        ? item[data.opt_id]
                        : item.value !== undefined
                          ? item.value
                          : "";
                  return (
                    <MenuItem key={index} value={String(itemId)}>
                      {item.value || item[data.opt_value]}
                    </MenuItem>
                  );
                })}
              </MUISelect>
              {data.error && (
                <FormHelperText>
                  {data.errmsg || "Selection Required"}
                </FormHelperText>
              )}
            </FormControl>
          </div>
        );
      }

      const searchText = (this.state.selectSearch || "").toLowerCase().trim();

      const normalize = (item) => getDisplayValue(item).trim();
      const firstName = (val) => (val.split(/\s|-/)[0] || "").toLowerCase();

      const filteredOptions = sortedDropdown
        .filter((item) => normalize(item).includes(searchText))
        .sort((a, b) => {
          // Keep options with keepAtTop at the top
          if (a.keepAtTop && !b.keepAtTop) return -1;
          if (!a.keepAtTop && b.keepAtTop) return 1;
          if (a.keepAtTop && b.keepAtTop) return 0;
          const aVal = normalize(a);
          const bVal = normalize(b);

          const aFirst = firstName(aVal);
          const bFirst = firstName(bVal);

          const aStarts = searchText && aFirst.startsWith(searchText);
          const bStarts = searchText && bFirst.startsWith(searchText);

          // Prioritize entries whose first name starts with the search text
          if (aStarts && !bStarts) return -1;
          if (!aStarts && bStarts) return 1;

          // Then sort alphabetically by first name
          const firstCompare = aFirst.localeCompare(bFirst);
          if (firstCompare !== 0) return firstCompare;

          // Fallback to full display value
          return aVal.localeCompare(bVal);
        });

      return (
        <div className="formdiv inputlabel">
          <FormControl fullWidth variant="outlined" error={data.error}>
            {data.labelname && (
              <InputLabel required={data.required}>{data.labelname}</InputLabel>
            )}

            <MUISelect
              label={data.labelname}
              value={this.props.value ?? ""}
              disabled={this.props.disabled}
              onMouseDown={(e) => this.setSelectWidth(e)}
              onOpen={(e) => {
                this.setSelectWidth(e);
              }}
              onChange={(e) => {
                this.props.changeData && this.props.changeData(e.target.value);
                this.setState({ selectSearch: "" });
              }}
              MenuProps={{
                disablePortal: true,
                disableAutoFocusItem: true,
                disableEnforceFocus: true,
                disableAutoFocus: false,
                PaperProps: {
                  style: {
                    maxHeight: 400,
                    ...(this.state.selectWidth
                      ? {
                          width: this.state.selectWidth,
                          minWidth: this.state.selectWidth,
                        }
                      : {}),
                  },
                },
              }}
            >
              {/* ✅ SEARCH BOX INSIDE DROPDOWN */}
              <ListSubheader className="dropdown-search-subheader">
                <div className="dropdown-search-box">
                  <Search className="dropdown-search-icon" />
                  <input
                    type="text"
                    autoFocus
                    value={this.state.selectSearch}
                    onChange={(e) => {
                      const nextSearch = e.target.value;
                      this.setState({ selectSearch: nextSearch });
                      this.props.onSelectSearchChange?.(nextSearch);
                    }}
                    placeholder={
                      this.props.selectSearchPlaceholder || "Search..."
                    }
                    onKeyDown={(e) => {
                      e.stopPropagation();
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </div>
              </ListSubheader>

              {/* ✅ FILTERED OPTIONS */}
              {filteredOptions.length > 0 ? (
                filteredOptions.map((item, index) => (
                  <MenuItem
                    className="search-highlight"
                    key={index}
                    value={
                      item.id !== undefined
                        ? item.id
                        : item[data.opt_id] !== undefined
                          ? item[data.opt_id]
                          : item.value !== undefined
                            ? item.value
                            : ""
                    }
                  >
                    {item.value || item[data.opt_value]}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No results found</MenuItem>
              )}
            </MUISelect>

            {data.error && (
              <FormHelperText>
                {data.errmsg || "Selection Required"}
              </FormHelperText>
            )}
          </FormControl>
        </div>
      );
    } else if (data.type === "mailbox") {
      return (
        <div className="formdiv">
          {data.labelname && (
            <label className="labeltxt">{data.labelname}</label>
          )}
          <TextField
            className={`${data.error && "mailbrdred"}`}
            required={this.props.required && this.props.required}
            variant="outlined"
            margin="normal"
            fullWidth
            // placeholder={"Email Address"}
            name="text"
            value={this.props.value && this.props.value}
            type="text"
            autoComplete={false}
            disabled={!!this.props.disabled}
            onChange={(e) =>
              this.props.changeData && this.props.changeData(e.target.value)
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <img src={Mail} alt="" />
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) =>
              this.props.onKeyEnter &&
              (e.code === "Enter" || e.key === "Enter") &&
              this.props.onKeyEnter(e.target.value)
            }
          />
          <div className="Errormsg">
            <div>{data.error && data.errmsg}</div>
          </div>
        </div>
      );
    } else if (data.type === "searchbox") {
      return (
        <div className="formdiv">
          <label className="labeltxt">{data.labelname}</label>
          <TextField
            required={this.props.required && this.props.required}
            variant="outlined"
            margin="normal"
            fullWidth
            placeholder="Search here"
            name="text"
            value={this.props.value && this.props.value}
            type="text"
            autoComplete={false}
            onChange={(e) =>
              this.props.changeData && this.props.changeData(e.target.value)
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <img src={search} alt="" />
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) =>
              this.props.onKeyEnter &&
              (e.code === "Enter" || e.key === "Enter") &&
              this.props.onKeyEnter(e.target.value)
            }
          />
          <div className="Errormsg">
            <div>{data.error && data.errmsg}</div>
          </div>
        </div>
      );
    } else if (data.type === "upload") {
      /**
       * @function onFileView to view the value
       * @param {string} url passing the url
       */
      function onFileView(url) {
        window.open(
          `${url}`,
          "Popup",
          "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30",
        );
      }

      return (
        <div className="inputlabel" style={{ lineHeight: 0 }}>
          {data.labelname && (
            <div className="labeltxt">
              <label>{data.labelname}</label>
              {data.required && <span className="asterisk">*</span>}
            </div>
          )}
          <div className={`${data.error && "brdred"} upload`}>
            <div className="upload-btn-wrapper" style={{ width: "100%" }}>
              {/* <Button icon={<img src={FileUpload} style={{ width: '1.3rem' }} />} text="Upload" /> */}
              <input
                id="finlo-upload"
                type="file"
                multiple
                accept="image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                // style={{ fontSize: 12 }}
                // value={this.props.value && this.props.value === [] && this.props.value ? this.props.value : ''}
                onChange={(e) =>
                  this.props.changeData && this.props.changeData(e.target.files)
                }
                disabled={this.props.disabled}
              />
            </div>
            {this.props.view_file &&
              this.props.view_file !== "null" &&
              this.props.view_file.length > 0 && (
                <>
                  <hr />
                  <div style={{ display: "flex", marginTop: -6 }}>
                    <div
                      style={{ width: "100%", cursor: "pointer" }}
                      onClick={() => onFileView(this.props.view_file)}
                    >
                      {this.props.view_file && this.props.view_file.length > 0
                        ? this.props.view_file.substr(35, 16).length > 15
                          ? `${this.props.view_file.substr(35, 16)}..`
                          : this.props.view_file.substr(35, 16)
                        : ""}
                    </div>
                    <img
                      src={Delete}
                      alt=""
                      onClick={() => this.setState({ upload_model: true })}
                      style={{
                        width: "20px",
                        cursor: "pointer",
                        padding: "3px",
                      }}
                    />
                  </div>
                </>
              )}
          </div>
          <div className="Errormsg">
            <div>{data.error && data.errmsg}</div>
          </div>
        </div>
      );
    } else if (data.type === "timeselector") {
      return (
        <div className="formdiv">
          <label className="labeltxt">{data.labelname}</label>
          <div>
            <TimePicker
              onChange={(e) =>
                this.props.changeData && this.props.changeData(e)
              }
              value={parseTimeToMoment(this.props.value) || undefined}
              autoComplete={"off"}
              minuteStep={5}
              defaultOpenValue={moment("00:00", "HH:mm")}
              disabledHours={() => data.disabledHours && data.disabledHours}
              disabledMinutes={() =>
                data.disabledMinutes && data.disabledMinutes
              }
              format={"HH:mm"}
              allowClear={false}
              disabled={!!this.props.disabled}
              getPopupContainer={(triggerNode) => {
                // Find the modal container or use document.body
                const modalContainer =
                  triggerNode.closest(".MuiDialog-root") ||
                  triggerNode.closest(".MuiDialog-container") ||
                  document.body;
                return modalContainer;
              }}
              popupStyle={{
                zIndex: 1400, // Higher than Material-UI Dialog default z-index (1300)
              }}
              // use12Hours
            />
            {
              <div className="Errormsg">
                <div>{data.error && data.errmsg}</div>
              </div>
            }
          </div>
        </div>
      );
    }
  }

  render() {
    const labelcss = require("./labelbox.css");
    return (
      <div className="custom_labelbox">{this.renderinput(this.props)}</div>
    );
  }
}
